import React from 'react';

import { useNavigate, useScreenLink } from '@gogame/screens';

import { homeDashboardScreenLink } from 'scenes/HomeDashboard/navigation';

export const ACTION_OPEN_NOTIFICATIONS_SETTINGS = 'NotificationsSettings';

export const NotificationsSettingsRedirect = () => {
  const navigate = useNavigate();

  const to = useScreenLink({ link: homeDashboardScreenLink });

  React.useEffect(() => {
    navigate(to, {
      state: { action: ACTION_OPEN_NOTIFICATIONS_SETTINGS },
    });
  }, []);

  return null;
};
